import { BriefcaseIcon, CurrencyEuroIcon, PencilIcon, PrinterIcon, SwitchHorizontalIcon } from '@heroicons/vue/solid'
import { i18n } from '../../../../localization'
import { RenderFunction } from 'vue'
import { LegalEsacComplianceProfile } from '../../../wizard/ESAC/legal/form/forms'
import LegalInvestmentObjectivesForm from '../../../wizard/ESAC/legal/form/LegalInvestmentObjectivesForm.vue'
import LegalFinancialConditionsForm from '../../../wizard/ESAC/legal/form/LegalFinancialConditionsForm.vue'
import LegalRiskToleranceForm from '../../../wizard/ESAC/legal/form/LegalRiskToleranceForm.vue'
import LegalFatcaDeclarationForm from '../../../wizard/ESAC/legal/form/LegalFatcaDeclarationForm.vue'
import LegalTaxSituationForm from '../../../wizard/ESAC/legal/form/LegalTaxSituationForm.vue'
import LegalCrsForm from '../../../wizard/ESAC/legal/form/LegalCrsForm.vue'
import LegalAcknowledgementsForm from '../../../wizard/ESAC/legal/form/LegalAcknowledgementsForm.vue'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'

export const esacLegalComplianceProfileConfig: EsacLegalComplianceProfileConfig = {
    'Investment Objectives': {
        component: LegalInvestmentObjectivesForm,
        icon: CurrencyEuroIcon,
        title: i18n.global.t('account_settings_legal.investment_objectives'),
        validationKey: 'investment_targets',
    },
    'Financial Conditions': {
        component: LegalFinancialConditionsForm,
        icon: BriefcaseIcon,
        title: i18n.global.t('account_settings_legal.financial_conditions'),
        validationKey: 'financial_conditions',
    },
    'Risk Tolerance': {
        component: LegalRiskToleranceForm,
        icon: SwitchHorizontalIcon,
        title: i18n.global.t('account_settings_legal.risk_tolerance'),
        validationKey: 'risk_tolerance',
    },
    'Fatca Declaration': {
        component: LegalFatcaDeclarationForm,
        icon: PrinterIcon,
        title: i18n.global.t('account_settings.fatca_declaration'),
        validationKey: 'fatca_declaration',
    },
    'Tax Situation': {
        component: LegalTaxSituationForm,
        icon: PencilIcon,
        title: i18n.global.t('account_settings_legal.tax_situation'),
        validationKey: 'tax_situation',
    },
    'CRS Declaration': {
        component: LegalCrsForm,
        icon: PencilIcon,
        title: i18n.global.t('account_settings_legal.crs_classification'),
        validationKey: 'crs_declaration',
    },
    'Acknowledgements': {
        component: LegalAcknowledgementsForm,
        icon: PencilIcon,
        title: i18n.global.t('account_settings.acknowledgements'),
        validationKey: 'acknowledgements',
    },
}

export interface EsacLegalComplianceProfileConfig {
    [key: string]: {
        component: any
        icon: RenderFunction
        title: string
        buttonTitle?: string
        validationKey: keyof LegalEsacComplianceProfile
        hideStatus?: boolean
        clearValuesOnClose?: boolean
        requireConfirm?: boolean
    }
}

export function isEsacLegalComplianceProfileLocked() {
    return useLegalAccountDataState().legalProfile.is_locked === true
}
